import "jquery/dist/jquery.min.js";
import Axios from "axios";
import $ from "jquery";
import EditForm from "@/pages/vehicles/editvehicle/editvehicle.vue";
import MarkAsBeingRepaired from "@/pages/vehicles/markasbeingrepaired/markasbeingrepaired.vue";
import VueGallery from "vue-gallery";
import DriverProfilePicture from "@/pages/drivers/driverprofilepicture/driverprofilepicture";
import DriverTag from "@/pages/drivers/drivertag/drivertag";
import UpcomingEvent from "@/pages/upcomingevent/upcomingevent";
import { faHourglassEmpty } from "@fortawesome/free-solid-svg-icons";
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import VehicleSorn from "@/pages/vehicles/vehiclesorn/vehiclesorn.vue";
import VehicleServiceHistory from "@/pages/vehicles/vehicleservicehistory/vehicleservicehistory.vue";
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
import VehicleChecks from "@/pages/vehicles/vehiclechecks/vehiclechecks.vue";
import VehicleMaps from '@/pages/vehicles/vehiclemaps/vehiclemaps.vue';
import { googleMapApiKey } from '@/constants/config';
import AddNotes from '@/pages/drivers/addnotes/addnotes';
import Notes from '@/pages/drivers/notes/notes';
import VehicleAssets from '@/pages/vehicles/vehicleassets/vehicleassets.vue';
import Task from "@/pages/task/task";
import VehicleInspectionsHistory from "@/pages/vehicles/vehicleinspactions/vehicleinspactions.vue";
import AuditLogs from '@/pages/auditlog/auditlogdata/auditlogdata.vue';
var moment = require("moment");

export default {
  components: {
    EditForm,
    MarkAsBeingRepaired,
    VueGallery,
    DriverProfilePicture,
    DriverTag,
    UpcomingEvent,
    VehicleSorn,
    DocumentPopup,
    VehicleServiceHistory,
    VehicleChecks,
    VehicleMaps,
    AddNotes,
    Notes,
    VehicleAssets,
    Task,
    VehicleInspectionsHistory,
    AuditLogs
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
    },
    short_date: function(data) {
			var sendDate = "N/A";
			if (data != "" && data != null) {
			sendDate = moment(data).format("MM-YYYY");
			}
			return sendDate;
        },
    region: function(data){
      return VehicleRegistrationRegion(data);
    }
  },
  data() {
    return {
      trackingModule: false,	
      VehicleImageEndpoint: Endpoints.Helper.GenerateImage + "/",
      ImageEndpoint: Endpoints.Helper.Image + "/",
      CompanyData:"",
      DocumentPopupAction:"Add",
      DocumentPopupCategory:"",
      DocumentPopupSubCategory:"",
      PopupLoader: false,
      ShowLoader: false,
      submitted: false,
      VehicleId: 0,
      editForm: false,
      SaveData: false,
      ShowCarCard: true,
      fromDate: "",
      toDate: "",
      vrm: "",
      inspectionFromDate: "",
      inspectionToDate: "",
      inspectionVRM: "",
      hgvModule: false,
      fuelTrackingModule: false,
      trailersModule:false,
      ShowViewDetailModel: false,
      AssetsList:[],
      NewVehicle: {
        vrm: "",
        date_reg_uk: "",
        make: "",
        model: "",
        year: "",
        class: "",
        color: "",
        engine_number: "",
        fuel_type: "",
        drive_type: "",
        body_type: "",
        engine_capacity: "",
        transmission: "",
        vin: "",
        keepers: "",
        fleet_number: "",
        current_mileage: "",
        mot_due: "",
        tax_due: "",
        insurance_expiry: "",
        lastservice_mile: "",
        lastservice_date: "",
        nextservice_mile: "",
        nextservice_date: "",
        tracker_status: "No_Tracker",
        fuel_status: "Fuel",
      },

      Drivers: [],
      Trailers: [],
      DocumentModelSubCategories:[],

      AssginVehicle: { driver_id: 0, vehicle_id: 0 },
      AssginTrailer: { trailer_id: 0, vehicle_id: 0 },

      NewDocument: {},
      DocumentModels: [],
      file: "",
      Services: [],
      Insurances: [],
      CheckFailures: [],
      VehicleChecks: [],
      VehicleNotes: "",
      ShowVehicleNotesModel: false,
      ShowVehicleNotesModelHeading: "Notes",

      VehicleInspectionNotes: "",
      ShowVehicleInspectionNotesModel: false,
      ShowVehicleInspectionNotesModelHeading: "Notes",

      Documents: [],
      SearchData: false,
      ShowVehicleCheckImageModel: false,
      excel_data: [],
      lightgallery: [],
      biglightgallery: [],
      gindex: 1,
      galleryoptions: {
        prevClass: "prev",
        nextClass: "next",
      },
      ComponentKey: 0,
      ProfilePicColor: "576E7A",
      DriverId: 0,

      VehicleInspections: [],
      CompanyInspections: [],
      SearchInspectionData: false,
      ShowSubmitVehicleInspectionModel: false,
      UniqueUrl:"",
      Mechanics:[],
      Mechanic :"",
      ShowEmailLoader : false,
      AttachMechanic : true,
      isMechanicAttached:false,

      ShowVehiclePositionModel: false,
      LastVehiclePosition: {},
      center: { 
       	lat: 55.232753,
       	lng: -3.944403
      },
      locationMarkers: [],
      AccountPermissions:[],
      ShowVehicleEdit:false,
      ShowVehicleDelete:false,
      ShowVehicleAssignDriver:false,
      ShowVehicleMarkAsBeingRepaired:false,
      ShowDocuments:false,
      ShowDocumentAdd:false,
      ShowDocumentEdit:false,
      ShowDocumentDelete:false,
      ShowGenerateURL:false,
      ShowVehicleInspections:false,
      ShowVehicleChecks:false,
      ShowUrgentTask:false,
      FleetSubscription:[],
      FuelByVehicle: {  series: [] },
      VehicleFuelData: [],
      areaspalinechart: {
        series: [
          /*{
              name: 'series1',
              data: [31, 40, 28, 51, 42, 109, 100],
            },
            {
              name: 'series2',
              data: [11, 32, 45, 32, 34, 52, 41],
            },*/
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: "area",
            zoom: {
              enabled: false,
            },
            toolbar: {
              show: false,
            },
            events: {
              click: function (event, chartContext, config) {
                FuelByVehicle = config.dataPointIndex;
              },
            },
          },
          markers: {
            size: [3, 4],
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
          },
          colors: ["#7366ff", "#f73164"],
          xaxis: {
            type: "text",
            categories: [],
          },
        },
      },
      InspectionClasses:[],
      VehicleEditFormData:[],
      lastUpdatedPosition:"",
      todaysUrgentTaskNew: window.todaysUrgentTaskNew,
    };
  },
  mounted() {
    //check account permission
    var AccountPermissions = JSON.parse(
      localStorage.getItem("AccountPermissions")
      );
    this.AccountPermissions = AccountPermissions;

    this.FleetSubscription = JSON.parse(
      localStorage.getItem("FleetSubscription")
    );

    var FleetSubscriptionModules = JSON.parse(
      this.FleetSubscription.fleet_modules
    );
    if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Vehicle || !AccountPermissions.Vehicle.enable || !AccountPermissions.Vehicle.view)){
      this.$router.push('/');
    }

    if (this.AccountPermissions && 
      this.AccountPermissions.Vehicle &&
      this.AccountPermissions.Vehicle.enable) {
      if ( this.AccountPermissions.Vehicle.edit) {
        this.ShowVehicleEdit = true;
      }
      if ( this.AccountPermissions.Vehicle.assign_driver) {
        this.ShowVehicleAssignDriver = true;
      }
      if ( this.AccountPermissions.Vehicle.mark_as_being_repaired) {
        this.ShowVehicleMarkAsBeingRepaired = true;
      }
      if ( this.AccountPermissions.Vehicle.delete) {
        this.ShowVehicleDelete = true;
      }
      if (
        AccountPermissions["HGV"] && 
        AccountPermissions["HGV"]["enable"]
      ) {
        this.ShowVehicleInspections = true;
        if (
          AccountPermissions["HGV"]["generate_inspection"]
        ) {
          this.ShowGenerateURL = true;
        }
      }      
    }
    if (AccountPermissions && 
      AccountPermissions['Vehicle Checks'] &&
      AccountPermissions['Vehicle Checks']['enable']) {
        if ( AccountPermissions['Vehicle Checks']['view_vehicle_checks']) {
          this.ShowVehicleChecks = true;
        }
        if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
          this.ShowUrgentTask = true;
        }
    }
    if (this.AccountPermissions && 
      this.AccountPermissions.Documents &&
      this.AccountPermissions.Documents.enable) {
        this.ShowDocuments = true;
        if ( this.AccountPermissions.Documents.add) {
          this.ShowDocumentAdd = true;
        }
        if ( this.AccountPermissions.Documents.edit) {
          this.ShowDocumentEdit = true;
        }
        if ( this.AccountPermissions.Documents.delete) {
          this.ShowDocumentDelete = true;
        }
      }
    if (!FleetSubscriptionModules["Hierarchy System"]) {
      this.ShowVehicleEdit = true;
      this.ShowVehicleAssignDriver = true;
      this.ShowVehicleMarkAsBeingRepaired = true;
      this.ShowDocuments = true;
      this.ShowDocumentAdd = true;
      this.ShowDocumentEdit = true;
      this.ShowDocumentDelete = true;
      this.ShowGenerateURL = true;
      this.ShowVehicleInspections = true;
      this.ShowVehicleChecks = true;
      this.ShowUrgentTask = true;
      this.ShowVehicleDelete = true;
    }

    this.CompanyData = JSON.parse(localStorage.getItem("Company"));
    if (this.CompanyData && this.CompanyData.name) {            
      if(window.taskModuleCompanies.includes(this.CompanyData.id)){ 
      	this.todaysUrgentTaskNew = true
      }
    }  
    document.title = pbx_SiteTitle + " - Vehicle Profile";
    this.VehicleId = this.$route.params.VehicleId;    
    setTimeout(() => {
      //this.GetCompanySubscription();
      this.GetVehicleDetail();
      this.GetFuelByVehicle();
      this.GetVehicleAssets();
      //this.DocumentModelLoadSubCategories();
      //this.GetVehicleServices();
      //this.GetVehicleInsurances();
      //this.DocumentModelLoad()
      //this.GetVehicleDocument();
    }, 1000);

  },

  methods: {
    GetVehicleAssets() {
      var obj = { token: localStorage.getItem("token") };
      obj.vehicle_id = this.VehicleId;      
      Axios.post(Endpoints.Vehicle.AssignedAssets, obj).then((Response) => {
        if (Response?.data?.success) {
          this.AssetsList = Response.data.AssetsList;          
        }
      });
    }, 
    AddNote(){
      this.$refs.add_notes_section.NewNoteOpen();
    },
    LoadNotesData(){
			this.$refs.notes_section.GetNotesList();
		},
    GetFuelByVehicle(type = "") {
      var obj = {
        token: localStorage.getItem("token"),
        category: "fuel",
        sub_category: "fuel",
        VehicleId:this.VehicleId
      };
      Axios.post(Endpoints.Report.FuelByVehicle, obj).then((Response) => {
        if (Response?.data?.success) {
          this.FuelByVehicle = {};
          var data = Response.data.services;          
          this.VehicleFuelData = Response.data.services;
          //if (data.length > 1) {
          this.FuelByVehicle.series = [
            { name: "Useage By Month", data: [] },
            { name: "Total Overall Useage", data: [] },
          ];
      
          data.forEach((element, index) => {
            this.FuelByVehicle.series[0]["data"].push(+element["volume"]);
            this.FuelByVehicle.series[1]["data"].push(+element["total_volume"]);

            this.areaspalinechart.chartOptions.xaxis.categories.push(
              element["date3"]
            );
          });
          //}
        }
      });
    },
    GetCompanySubscription() {
      var FleetSubscriptionModules = JSON.parse(
				JSON.parse(localStorage.getItem("FleetSubscription")).fleet_modules
			);
			const isHGV = FleetSubscriptionModules.HGV;
      if (isHGV) {
        this.hgvModule = true;
      }
      const isTracking = FleetSubscriptionModules["Vehicle Tracking"];
      if (isTracking) {
        this.trackingModule = true;
      }
      const isTrailer = FleetSubscriptionModules.Trailers;
      if (isTrailer) {
        this.trailersModule = true;
      }
      const isFuelTracking = FleetSubscriptionModules["Fuel Tracking"];
      if (isFuelTracking) {
        this.fuelTrackingModule = true;
      }

      if(localStorage.getItem("InspectionsClasses")){
        var InsClasses = JSON.parse(localStorage.getItem("InspectionsClasses"));
        InsClasses.forEach((element, index) => {
          let addClass = true;
          if(element.title == "HGV" || element.title == "HCV" ){
            addClass = false;
            if(this.hgvModule){
              addClass = true;
            }
          }
          if(addClass){
            if(element.title == "HCV" ){
              element.title = "HGV" ;
            }
            this.InspectionClasses.push(element.title);
          }
        });
      }
      this.DocumentModelLoadSubCategories();
      
    },
    ViewDetailDocument (document){
      this.$refs.EditForm.ViewDocumentDetails(document);
    },
    forceRerender() {
      this.ComponentKey += 1;
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    SetVehicleTrackerStatus(type) {
      this.NewVehicle.tracker_status = type;
    },
    SetFuelStatus(type) {
      this.NewVehicle.fuel_status = type;
    },
    SetCardType(type){
      this.ShowCarCard = type == 'Car' ? true : false;
    },
    LoadProfileData(){
      this.GetVehicleDetail();
    },
    LoadHistory() {
      this.$refs.service_history.GetVehicleServices();
      this.$refs.EditForm.GetDocumentList();
      if(this.ShowVehicleInspections){
        this.$refs.inspection_history.GetVehicleInspectionsList();
      }  
    },
    GetVehicleDetail() {
      this.ShowLoader = true;
      Axios.post(Endpoints.Vehicle.Get, {
        token: localStorage.getItem("token"),
        vehicle_id: this.VehicleId,
      }).then((Response) => {
        this.ShowLoader = false;
        if (Response?.data?.success) {
          this.NewVehicle = Response.data.vehicle;
          this.vrm = this.NewVehicle.vrm;
          this.inspectionVRM = this.NewVehicle.vrm;
          this.VehicleEditFormData = this.NewVehicle;

          if (this.NewVehicle.driver && this.NewVehicle.driver.driver) {
            this.DriverId = this.NewVehicle.driver.driver.id;
            if (sessionStorage.getItem("DriverColor") != null) {
              this.DriverColor = JSON.parse(
                sessionStorage.getItem("DriverColor")
              );
              if (typeof this.DriverColor[this.DriverId] != "undefined") {
                this.ProfilePicColor = this.DriverColor[this.DriverId];
              }
            }
          }
          this.GetCompanySubscription();
          this.forceRerender();
        }else{
        	this.$router.push("/error-404");
        }
      });
    },

    GetVehicleServices() {
      Axios.post(Endpoints.Vehicle.Services, {
        token: localStorage.getItem("token"),
        vehicle_id: this.VehicleId,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.Services = Response.data.services;
        }
      });
    },
    GetVehicleInsurances() {
      /* Axios.post(Endpoints.Vehicle.Insurances, {
        token: localStorage.getItem("token"),
        vehicle_id: this.VehicleId,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.Insurances = Response.data.insurances;
        }
      }); */
    },
    GetTrailersList() {
      Axios.post(Endpoints.Trailer.ListForAssignTrailer, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          this.Trailers = Response.data.trailers;
        }
      });
    },
    GetDriversList() {
      Axios.post(Endpoints.Driver.List, {
        token: localStorage.getItem("token"),
      }).then((Response) => {
        if (Response?.data?.success) {
          this.Drivers = Response.data.drivers;
        }
      });
    },
    AssignTrailer(vehicle_id) {
      this.AssginTrailer.trailer_id = 0;
      this.AssginTrailer.vehicle_id = vehicle_id;
      this.GetTrailersList();
    },
    SubmitAssignTrailer() {
      this.$swal.fire({
        title: "Assigning...",
        text: "Please wait...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      if (
        this.AssginTrailer.vehicle_id > 0 &&
        this.AssginTrailer.trailer_id > 0
      ) {
        Axios.post(Endpoints.Trailer.AssginVehicle, {
          token: localStorage.getItem("token"),
          trailer_id: this.AssginTrailer.trailer_id,
          vehicle_id: this.AssginTrailer.vehicle_id,
        }).then((Response) => {
          if (Response?.data?.success == true) {
            this.AssginTrailer.trailer_id = 0;
            this.GetVehicleDetail();
            this.GetTrailersList();
            $("#assign-trailer .btn-danger").trigger("click");
            this.$swal
              .fire("Trailer Assigned Successfully", "", "success")
              .then(() => {});
          } else {
            this.$swal
              .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
              .then(() => {});
          }
        });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Please Select Trailer",
        });
      }
    },
    UnAssignTrailer(vehicle_link_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to UnAssign this Trailer?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, UnAssign it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Removing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Trailer.UnAssginVehicle, {
              token: localStorage.getItem("token"),
              vehicle_link_id: vehicle_link_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.GetVehicleDetail();
                this.GetTrailersList();
                this.$swal
                  .fire("Trailer UnAssigned Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    UnAssignDriver(vehicle_link_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to UnAssign this Driver?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, UnAssign it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Removing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Driver.UnAssginVehicle, {
              token: localStorage.getItem("token"),
              vehicle_link_id: vehicle_link_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.GetVehicleDetail();
                this.$swal
                  .fire("Driver UnAssigned Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    AssignDriver(vehicle_id) {
      this.AssginVehicle.vehicle_id = vehicle_id;
      this.AssginVehicle.driver_id = 0;
      this.GetDriversList();
    },
    SubmitAssignDriver() {
      this.$swal.fire({
        title: "Assigning...",
        text: "Please wait...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      if (
        this.AssginVehicle.vehicle_id > 0 &&
        this.AssginVehicle.driver_id > 0
      ) {
        Axios.post(Endpoints.Driver.AssginVehicle, {
          token: localStorage.getItem("token"),
          driver_id: this.AssginVehicle.driver_id,
          vehicle_id: this.AssginVehicle.vehicle_id,
        }).then((Response) => {
          if (Response?.data?.success == true) {
            this.GetVehicleDetail();
            $("#assign-driver .btn-danger").trigger("click");
            this.$swal
              .fire("Driver Assigned Successfully", "", "success")
              .then(() => {});
          } else {
            this.$swal
              .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
              .then(() => {});
          }
        });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Please Select Driver",
        });
      }
    },

    DocumentModelLoad(scope) {
      this.PopupLoader = true;
      this.DocumentModels = [];
      Axios.post(Endpoints.Dcoument.Model, {
        token: localStorage.getItem("token"),
        scope: scope,
      }).then((Response) => {
        this.PopupLoader = false;
        if (Response?.data?.success == true) {
          if (Response.data.models.length > 0) {
            Response.data.models.forEach((element) => {
              this.DocumentModels.push({
                id: element.id,
                title: element.title,
              });
            });
            this.DocumentModels.push({ id: -1, title: "Add New" });
          } else {
            this.DocumentModels.push({ id: -1, title: "Add New" });
          }
        }
      });
    },
    onSelectDocumentType() {
      if (this.NewDocument.type == "-1" || this.NewDocument.type == "0") {
        this.NewDocument.title = "";
        this.NewDocument.category = "";
        this.NewDocument.sub_category = "";
        this.NewDocument.fields = {};
        this.NewDocument.new_type_name = "";
        var obj = {
          expiry: { title: "Expiry", type: "date", sort_order: 1 },
        };
        this.NewDocument.fields = obj;
      }
      if (this.NewDocument.type != 0) {
        this.PopupLoader = true;
        Axios.post(Endpoints.Dcoument.Model, {
          token: localStorage.getItem("token"),
          id: this.NewDocument.type,
        }).then((Response) => {
          this.PopupLoader = false;
          if (Response?.data?.success == true && Response.data.models[0]) {
            var model = Response.data.models[0];
            this.NewDocument.title = model.title;
            this.NewDocument.category = model.category;
            this.NewDocument.sub_category = model.sub_category;
            this.NewDocument.fields = JSON.parse(model.fields);
            /*if(model.category=='vehicle' && model.sub_category=='other'){
						this.NewDocument.fields = {"vehicle":{"title":"Vehicle","type":"text","sort_order":5,"value":this.DealData.vrm}}
						}*/
            if (this.NewDocument.fields && this.NewDocument.fields.vehicle) {
              this.NewDocument.fields.vehicle.value = this.NewVehicle.vrm;
            }
          }
        });
      }
    },
   
    GetVehicleDocument() {
      Axios.post(Endpoints.Vehicle.Documents, {
        token: localStorage.getItem("token"),
        vehicle_id: this.VehicleId,
      }).then((Response) => {
        if (Response?.data?.success) {
          this.Documents = {
            documents: Response.data.documents.data,
            page: 1,
            last_page: Response.data.documents.last_page,
          };
        }
      });
    },
    ViewMore(currentPage){
      var nextPage = currentPage + 1;
      Axios.post(Endpoints.Vehicle.DocumentPagination, {
        token: localStorage.getItem("token"),
        vehicle_id: this.VehicleId,
        page:nextPage
      }).then((Response) => {
        if (Response?.data?.success) {
          this.Documents.page = nextPage;
          this.Documents.last_page = Response.data.documents.last_page;
          Response.data.documents.data.forEach((element) => {
            this.Documents.documents.push(
              element
            );
          });
        }
      });
    },
    DeleteVehicleDocument(document_id) {
      this.$swal({
        title: "Are you sure You want to delete?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal.fire({
            title: "Deleting...",
            text: "Please wait...",
            showConfirmButton: false,
            allowOutsideClick: false,
          });
          Axios.post(Endpoints.Dcoument.Delete, {
            token: localStorage.getItem("token"),
            document_id: document_id,
          }).then((Response) => {
            if (Response?.data?.success === true) {
              this.$swal.close();
              this.$refs.EditForm.GetDocumentList();
              this.$refs.inspection_history.GetVehicleInspectionsList();
              this.$swal
                .fire("Document Deleted Successfully", "", "success")
                .then(() => {});
            } else {
              this.$swal
                .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                .then(() => {});
            }
          });
        }
      });
    },
    
    DocumentModelLoadSubCategories() {
      Axios.post(Endpoints.Dcoument.SubCategories, {
        token: localStorage.getItem("token"),
        category: 'vehicle',
      }).then((Response) => {
        if (Response?.data?.success == true && Response.data.subcategories) {
          Response.data.subcategories.forEach((element) => {
            if(element == 'brakes'){
              if(this.hgvModule && (this.NewVehicle.class == 'HGV' || this.NewVehicle.class == 'HCV')){
                this.DocumentModelSubCategories.push({
                  id: element,
                  title: 'Brakes Record',
                });
              }
            }else if(element == 'PMI'){
              if(this.InspectionClasses.includes(this.NewVehicle.class) &&
              this.NewVehicle.class != 'Crane'){
                this.DocumentModelSubCategories.push({
                  id: element,
                  title: 'PMI Inspection',
                });
              }
            }else{
              this.DocumentModelSubCategories.push({
                id: element,
                title: element.replace("_", " "),
              });
            }
            
          });
        }

      });
    },
    AddDocument(type = "") {
      var heading = '';
      if(type == 'insurance'){
        heading = 'Insurance';
      }else if(type == 'brakes'){
        heading = 'Brakes Test';
      }else if(type == 'service'){
        heading = 'Service';
      }else if(type == 'finance'){
        heading = 'Finance';
      }else if(type == 'warranty'){
        heading = 'Warranty';
      }else if(type == 'other'){
        heading = 'Other Documents';
      }else if(type == 'Toll Charges'){
        heading = 'Toll Charges';
      }else if(type == 'Accident Reports'){
        heading = 'Accident Reports';
      }else if(type == 'PMI'){
        heading = 'PMI';
      }
      var category = "vehicle";
      this.NewDocument={};
      this.DocumentPopupCategory = category;
      this.DocumentPopupSubCategory = type;
      this.$refs.popup.loadPopupModal(type,heading);
    },
    EditDocument(document) {
     this.$refs.popup.loadEditData(document);
    },
    DeleteDocument(document_id) {
      this.$refs.popup.DeleteDocumentData(document_id);
    },
    ViewDocumentFile(files) {
      this.$swal.fire({
        title: "Downloading...",
        text: "Please wait...",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      Axios.post(Endpoints.File.Get, {
        token: localStorage.getItem("token"),
        file: files,
      }).then((Response) => {
        if (Response?.data?.success == true) {
          this.$swal.close();
          window.open(Response.data.file, "_blank");
        } else {
          this.$swal
            .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
            .then(() => {});
        }
      });
    },
    DeleteVehicle(vehicle_id) {
      this.$swal
        .fire({
          title: "Are you sure You want to delete this Vehicle?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Deleting...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Vehicle.Delete, {
              token: localStorage.getItem("token"),
              id: vehicle_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.$router.push("/vehicles-list");
                this.$swal
                  .fire("Vehicle Deleted Successfully", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    SornVehicle(vehicle_id) {
      this.$swal
        .fire({
          title: "Sorn Vehicle",
          text: "You are about to mark this vehicle as sorn vehicle",
          //icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Continue",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Processing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Vehicle.Sorn, {
              token: localStorage.getItem("token"),
              vehicle_id: vehicle_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.NewVehicle.sorn = 1;
                this.$swal
                  .fire(
                    "Vehicle Mark as Sorned Vehicle Successfully",
                    "",
                    "success"
                  )
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    UnSornVehicle(vehicle_id) {
      this.$swal
        .fire({
          title: "Unsorn Vehicle",
          text: "You are about to mark this vehicle as Unsorn Vehicle",
          //icon: 'warning',
          showCancelButton: true,
          confirmButtonText: "Continue",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$swal.fire({
              title: "Processing...",
              text: "Please wait...",
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            Axios.post(Endpoints.Vehicle.Unsorn, {
              token: localStorage.getItem("token"),
              vehicle_id: vehicle_id,
            }).then((Response) => {
              if (Response?.data?.success == true) {
                this.NewVehicle.sorn = 0;
                this.$swal
                  .fire("Vehicle Mark as Unsorn Vehicle", "", "success")
                  .then(() => {});
              } else {
                this.$swal
                  .fire("Error:" + Response?.data?.message || "Something went wrong", "", "error")
                  .then(() => {});
              }
            });
          }
        });
    },
    AddDocumentSubmit() {
      this.NewDocument.vehicle_id = this.NewVehicle.id;
      this.NewDocument.export_type = 1;
      this.NewDocument.scope = 1;
      var error = false;
      var errorStr = "";
      if (this.NewDocument.fields) {
        for (const [key, ele] of Object.entries(this.NewDocument.fields)) {        	
          if (ele.required && (!ele.value || ele.value == "")) {
            error = true;
            errorStr += "<li>Please Enter " + ele.title + "</li>";
          }
          if(key=='mileage' && ele.value <= 0){
          	error = true;
            errorStr += "<li>Mileage should be greator then 0</li>";
          }
        }
      }
      if (error == true) {
        this.$swal
          .fire("Following Error Found!", errorStr, "error")
          .then(() => {});
      } else {
        this.$swal.fire({
          title: "Adding " + this.NewDocument.title + "...",
          text: "Please wait...",
          showConfirmButton: false,
          allowOutsideClick: false,
        });
        this.PopupLoader = true;
        this.NewDocument.token = localStorage.getItem("token");
        Axios.post(Endpoints.Dcoument.Create, this.NewDocument).then(
          (Response) => {
            this.PopupLoader = false;
            if (Response?.data?.success == true) {
              this.ShowAddDocument = false;
              if (this.NewDocument.type == "service") {
                this.GetVehicleServices();
              }
              if (this.NewDocument.type == "insurance") {
                //this.GetVehicleInsurances();
              }
              if (this.NewDocument.type == "PMI") {
                this.$refs.inspection_history.GetVehicleInspectionsList();
                //this.GetVehicleInsurances();
              }
              $("#AddDocumentPopup .btn-danger").trigger("click");
              var msg = this.NewDocument.title + " Added Successfully";
              if(this.NewDocument.id && this.NewDocument.id > 0){
              	msg = this.NewDocument.title + " Updated Successfully";
              }
              this.$swal
                .fire(
                  msg,
                  "",
                  "success"
                )
                .then(() => {});
              this.NewDocument = {};
            } else {
              this.$swal
                .fire(Response?.data?.message || "Something went wrong", "", "error")
                .then(() => {});
            }
          }
        );
      }
    },
    ShowVehicleImage(VehicleCheck) {
      this.ShowVehicleCheckImageModel = true;
      this.lightgallery = JSON.parse(VehicleCheck.photo);
      this.biglightgallery = JSON.parse(VehicleCheck.photo);
      for (var i = 0; i < this.biglightgallery.length; i++) {
        this.biglightgallery[i] =
          Endpoints.Helper.Image + "/" + this.biglightgallery[i];
      }
    },
    ShowVehiclePosition(){
    	this.ShowVehiclePositionModel = true;
    	setTimeout(() => {
    		this.$refs.VehicleMaps.ShowVehicleMaps()
    	},500);
    },
  },
};